import { render, staticRenderFns } from "./SendSpeak.vue?vue&type=template&id=3053617d&scoped=true&"
import script from "./SendSpeak.vue?vue&type=script&lang=ts&"
export * from "./SendSpeak.vue?vue&type=script&lang=ts&"
import style0 from "./SendSpeak.vue?vue&type=style&index=0&id=3053617d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3053617d",
  null
  
)

export default component.exports